import api from "./api";
import { generateErrorMessage } from "../utils/message";


/*Users*/
export const registerUser = async (userData) => {
  try {
    const response = await api.post("/users", userData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("register", "user");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const fetchUsersFromAPI = async (page = 1, perPage = 10, search = "", columnFilters = {}, sort = {}) => {
  try {
    // Build params object with column-specific filters
    const params = {
      page,
      per_page: perPage
    };

    // Add search parameter if provided (for backward compatibility)
    if (search) {
      params.search = search;
    }

    // Add column-specific parameters
    if (columnFilters.name) params.name = columnFilters.name;
    if (columnFilters.username) params.username = columnFilters.username;
    if (columnFilters.email) params.email = columnFilters.email;
    if (columnFilters.role) params.role = columnFilters.role;

    if (sort && sort.sortBy) {
      params.sort_by = sort.sortBy;
      params.sort_dir = sort.sortDir === 'desc' ? 'desc' : 'asc';
    }

    const response = await api.get("/users", {
      params: params,
    });

    return response.data.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data", "user");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};


/* Fetch every user matching the filters, walking server pages (for Export). */
export const fetchAllUsersForExport = async ({ search = "", columnFilters = {}, sort = {} } = {}, onProgress) => {
  const PER_PAGE = 1000;
  const collected = [];
  let page = 1;
  let total = 0;
  for (;;) {
    const response = await fetchUsersFromAPI(page, PER_PAGE, search, columnFilters, sort);
    const payload = response?.users || {};
    const rows = Array.isArray(payload.data) ? payload.data : [];
    collected.push(...rows);
    total = Number(payload.total) || collected.length;
    if (onProgress) onProgress(collected.length, total);
    const lastPage = Number(payload.last_page) || 1;
    if (rows.length === 0 || page >= lastPage || collected.length >= total) break;
    page += 1;
  }
  return collected;
};

export const deleteUsersFromAPI = async (userId) => {
  try {
    const response = await api.delete(`/users/${userId}`, {
      params: { user_id: userId },
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("delete data", "user");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};


export const fetchUsersById = async (userId) => {
  try {
    const response = await api.get(`/users/${userId}`);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data user", "user");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const updateUser = async (id, userData) => {
  try {
    const response = await api.put(`/users/${id}`, userData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("update", "user");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

/**
 * E-mail the user a one-time link to set a new password and/or PIN themselves.
 * type: "password" | "pin" | "both". Admin only.
 */
export const requestCredentialReset = async (userId, type) => {
  try {
    const response = await api.post(`/users/${userId}/credential-reset`, { type });
    return response.data.data;
  } catch (error) {
    const fallback = generateErrorMessage("send reset link", "user");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

/* 📌 Upload User Excel File */
export const uploadUserFileToAPI = async (formData, onUploadProgress) => {
  try {
    const response = await api.post("/users/submit-excel", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      // Reports how much of the FILE has reached the server (0-100). Server-side
      // row inserting happens after this hits 100 and is not tracked here.
      onUploadProgress: onUploadProgress
        ? (event) => {
            if (event.total) {
              onUploadProgress(Math.round((event.loaded / event.total) * 100));
            }
          }
        : undefined,
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("upload user file", "user");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};


